import { setDisplayName, compose, withProps } from 'recompose';
import {
  withCheckableOptionGroupStyle,
  withAutoSizeOptionContainer,
  CheckableOptionGroup,
} from '@nextiva/engagement-ui';
import withFormCheckableGroupHandlers from '../hoc/withFormCheckableGroupHandlers';

import styles from './CheckableOptionGroupField.scss';

export default compose(
  setDisplayName('CheckableOptionGroupField'),
  withCheckableOptionGroupStyle,
  withAutoSizeOptionContainer,
  withFormCheckableGroupHandlers,
  withProps({
    errorMessageClassName: styles.errorMessage,
  }),
)(CheckableOptionGroup);
